import { render, staticRenderFns } from "./BigButtons.vue?vue&type=template&id=74da22fc&scoped=true&"
import script from "./BigButtons.vue?vue&type=script&lang=js&"
export * from "./BigButtons.vue?vue&type=script&lang=js&"
import style0 from "./BigButtons.vue?vue&type=style&index=0&id=74da22fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da22fc",
  null
  
)

export default component.exports